// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.advanced-role-mapping{display:flex;justify-content:space-evenly}.delete-advanced-role-mapping{position:relative;top:40px}`, "",{"version":3,"sources":["webpack://./src/components/ldap/advancedRoleMappings/advancedRoleMapping/style.scss"],"names":[],"mappings":"AAAA,uBACI,YAAA,CACA,4BAAA,CAGJ,8BACI,iBAAA,CACA,QAAA","sourcesContent":[".advanced-role-mapping{\n    display: flex;\n    justify-content: space-evenly;\n}\n\n.delete-advanced-role-mapping{\n    position: relative;\n    top: 40px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"advancedRoleMapping": `advanced-role-mapping`,
	"deleteAdvancedRoleMapping": `delete-advanced-role-mapping`
};
export default ___CSS_LOADER_EXPORT___;
